<template>
<span class="value-origin" :title="$t('models.project_lead.origins.' + value)" :class="'origin-' + value"><i class="icon">{{icon}}</i></span>
</template>
<script>
export default {
  props: ['item', 'column', 'model'],
  computed: {
    value(){
      return eval('this.item.' + this.column.name)
    },
    icon(){
      if(this.value == 'mobile_app'){
        return "phone_iphone"
      }
      else if(this.value == 'web_app'){
        return "cloud"
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.origin-mobile_app, .origin-web_app{
  color: #959595;
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// CollectionValueOrigin.vue?409eb8ca